module.exports = __webpack_public_path__ + "img/Icon-Outils.e668f7dd.svg";